import styled from "styled-components";
import { theme } from "../../../../../../../../constants/StyledComponents";

export const StyledManagePathsGrades = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  padding: 16px 0 16px 16px;
  margin-top: 53px;
  flex-direction: column;

  & .table-row {
    display: table-row;
    width: 334px !important;
  }

  & .table-cell {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }

  & .columns-container {
    display: flex;
    gap: 16px;
    z-index: 1;
  }

  & .background-container {
    position: absolute;
    z-index: 1;
  }
`;

export const StyledPathGradeItem = styled.div<{
  $isDragging: boolean;
  $isDragDisabled: boolean;
  $isNew: boolean;
  $isEditable: boolean;
}>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 0 16px 0 16px;
  width: 300px;
  height: 48px;
  cursor: ${(props) => (props.$isDragDisabled ? "default" : "pointer")};
  pointer-events: ${(props) => (props.$isDragDisabled ? "none" : "auto")};
  margin-bottom: 8px;
  border-radius: ${theme.variables.border_radius_1};
  border: 1px solid ${theme.colors.purple};
  background-color: ${(props) =>
    props.$isDragging ? theme.colors.purple_2 : theme.colors.white};
  justify-content: space-between;

  & > div {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;

    & > span > span {
      width: 190px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      text-align: left;
    }
  }

  & > .path-grade-actions:last-child {
    visibility: ${(props) => (props.$isNew ? "visible" : "hidden")};

    & > div {
      cursor: pointer;
    }
  }

  &:hover {
    background-color: ${(props) =>
      props.$isEditable ? theme.colors.purple_2 : ""};

    & > .path-grade-actions:last-child {
      visibility: ${(props) => (props.$isEditable ? "visible" : "hidden")};
    }
  }

  & > .path-grade-actions-editing {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
  }

  & > .path-grade-input {
    width: 100%;
  }
`;

export const StyledEmptyItem = styled.div<{
  $isDraggingOver: boolean;
  $isEditable: boolean;
  $createNewItem: boolean;
}>`
  height: 48px;
  border: ${(props) =>
    props.$createNewItem
      ? `1px dotted ${theme.colors.purple}`
      : "1px dotted transparent"};
  margin-bottom: 8px;
  padding: 0 16px 0 16px;
  background-color: ${(props) =>
    props.$createNewItem ? theme.colors.purple_2 : "transparent"};
  opacity: ${(props) => (props.$createNewItem ? "1" : "0.3")};
  border-radius: ${theme.variables.border_radius_1};
  align-items: center;
  display: flex;
  justify-content: ${(props) =>
    props.$createNewItem ? "space-between" : "center"};

  ${(props) =>
    (props.$isEditable || props.$createNewItem) &&
    `
      cursor: pointer;
      gap: 12px;

      &:hover {
        border-color: ${theme.colors.purple};
        background-color: ${theme.colors.purple_2};
        opacity: 1;
      }
    `}

  & > .path-grade-actions-editing {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
  }

  & > .path-grade-input {
    width: 100%;
  }
`;

export const CreateElement = styled.div<{ $isEditable: boolean }>`
  display: none;
  color: ${theme.colors.purple};
  font-weight: bold;
  text-align: center;
  transition: opacity 100ms linear;

  ${StyledEmptyItem}:hover & {
    display: ${(props) => (props.$isEditable ? "flex" : "none")};
    align-items: center;
  }
`;

export const StyledDroppableItem = styled.div<{ $isInvisible: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 16px;
  width: 300px;
  height: 48px;
  margin-bottom: 8px;
  border-radius: ${theme.variables.border_radius_1};
  border: 1px solid ${theme.colors.grey_3};
  background-color: ${theme.colors.white};
  border-style: dashed;
  visibility: ${(props) => (props.$isInvisible ? "hidden" : "visible")};
`;
